module["exports"] = ["+90-53#-###-##-##", "+90-54#-###-##-##", "+90-55#-###-##-##", "+90-50#-###-##-##"];